
import { AutocompleteDTO, EnglishArabicDTO } from "bnsights-control-library"
export class ParticipantModel
{
      ID?:number
      ParticipantTypeItemID:number
      ParticipantTypeItemIDsString:string
      CorrelationID:any
      PermissionSetID?:number
      UserID?:number
      PermissionSetIDsString:string
      WorkflowVariableID:number
      WorkflowActivityID?:number
      Description:EnglishArabicDTO= new EnglishArabicDTO();
      ParticipantName:EnglishArabicDTO= new EnglishArabicDTO();
      ParticipantTypeItemName:EnglishArabicDTO= new EnglishArabicDTO();   

}